import Landing from '../LandingPages/Landing'
import Features from '../LandingPages/Features'
import WhyChoose from '../LandingPages/Whychoose'
import GetStart from '../LandingPages/GetStart'

function Home() {
    return (
        <div className='min-h-[90vh]'>
            <Landing />
            <Features />
            <WhyChoose />
            <GetStart />
        </div>
    )
}

export default Home